module.exports = __webpack_public_path__ + "img/Qinghai-speed.f76f266b.png";